<template>
  <router-view v-if="!resources.loadingLanguage" />
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'App',
  beforeCreate() {
    this.$store.dispatch('setLanguage')
  },
  computed: {
    ...mapGetters({
      resources: 'resources',
    }),
  },
}
</script>

<style lang="scss">
@import './styles/app.scss';
@import '~@/styles/custom/colors';

html,
body {
  height: 100%;
  width: 100%;
  margin: 0px;
  padding: 0px;
  display: flex;
  outline: 0;
  font-family: 'Poppins';
  background-color: map-get($theme-colors, 'new-primary');
}
</style>
